import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ContextProvider } from './context/UserContext';
import * as Yup from 'yup';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

Yup.setLocale({
  mixed: {
    required: 'وارد کردن این فیلد اجباری است',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ContextProvider>
    <BrowserRouter>
      <ToastContainer />
      <App />
    </BrowserRouter>
  </ContextProvider>
);
reportWebVitals();
